import * as React from 'react';

import ActionLink from 'components/buttons/action-link/ActionLink';

type Props = {
  decoratedText: string
};

const RichTextEditorUrl = (props: Props) => {
  const url = props.decoratedText;
  return (
    <ActionLink
      link={url}
      size="inherit"
      color="light"
      inline
      openInNewTab
    >
      {url}
    </ActionLink>
  );
};

export default RichTextEditorUrl;
